<script setup lang="ts" generic="T extends string">
const props = defineProps<{
  start: T
  options: T[]
}>()

type RenderOption = { now: T; open: boolean; next: T }

function getNext(now: string | undefined, options: T[]) {
  const index = options.findIndex((i) => i === now)
  return options[index + 1] || options[0]
}

function startCalc(now: T, options: T[]): RenderOption[] {
  const next = getNext(now, options)
  const nextNext = getNext(next, options)
  if (!next || !nextNext) return []
  return [{ now, next, open: true }, { now: next, next: nextNext, open: false }]
}

const renderOptions = shallowRef<RenderOption[]>(startCalc(props.start, props.options))

type PropsWatch = { start: T; options: T[] }
let prev: undefined | PropsWatch

function isEqual(a: PropsWatch, b: PropsWatch): boolean {
  if (a.start !== b.start) return false
  if (a.options.length !== b.options.length) return false
  return a.options.every((i, index) => i === b.options[index])
}

watch(
  () => ({ start: props.start, options: props.options }),
  (i) => {
    if (prev && isEqual(i, prev)) return
    prev = i
    renderOptions.value = startCalc(i.start, i.options)
  },
  { immediate: true },
)

const timer = useTimeout()
function toNext() {
  const options = props.options
  const now = renderOptions.value.find((i) => i.open)?.now || options[0]
  const next = getNext(now, options)
  const nextNext = getNext(next, options)
  if (!next || !nextNext || !now) return []

  renderOptions.value = [
    { now, next, open: true },
    { now: next, next: nextNext, open: false },
  ]
  timer.set(() => {
    renderOptions.value = [
      { now, next, open: false },
      { now: next, next: nextNext, open: true },
    ]
  }, 10)
}
</script>

<template>
  <div class="_col">
    <UiGrow v-for="item in renderOptions" :key="item.now" :open="item.open">
      <slot :show="item.now" />
    </UiGrow>

    <div class="_hm60">
      <UiGrow v-for="item in renderOptions" :key="item.now" :open="item.open">
        <div class="_pt2">
          <slot name="button" :show="item.next" :to-next="toNext" />
        </div>
      </UiGrow>
    </div>
  </div>
</template>
